module.exports = __webpack_public_path__ + "static/img_9608-01ce89fb8b77e51bdc44469688e27a2f.webp";